/**
 * @generated SignedSource<<b71b3b149cc6f0e08bf0c43553295948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePopupSettingInput = {
  clientMutationId?: string | null;
  popupSettingId: string;
};
export type PopupSetDetailLinkedPopupListTableActions_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePopupSettingInput;
};
export type PopupSetDetailLinkedPopupListTableActions_MutationVariables = PopupSetDetailLinkedPopupListTableActions_Mutation$variables;
export type PopupSetDetailLinkedPopupListTableActions_Mutation$data = {
  readonly deletePopupSetting: {
    readonly deletedPopupSettingId: string;
  } | null;
};
export type PopupSetDetailLinkedPopupListTableActions_MutationResponse = PopupSetDetailLinkedPopupListTableActions_Mutation$data;
export type PopupSetDetailLinkedPopupListTableActions_Mutation = {
  variables: PopupSetDetailLinkedPopupListTableActions_MutationVariables;
  response: PopupSetDetailLinkedPopupListTableActions_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPopupSettingId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupSetDetailLinkedPopupListTableActions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupSettingPayload",
        "kind": "LinkedField",
        "name": "deletePopupSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupSetDetailLinkedPopupListTableActions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupSettingPayload",
        "kind": "LinkedField",
        "name": "deletePopupSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPopupSettingId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a2078ae65dff8d4ac2212f5afd8c5c48",
    "id": null,
    "metadata": {},
    "name": "PopupSetDetailLinkedPopupListTableActions_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupSetDetailLinkedPopupListTableActions_Mutation(\n  $input: DeletePopupSettingInput!\n) {\n  deletePopupSetting(input: $input) {\n    deletedPopupSettingId\n  }\n}\n"
  }
};
})();

(node as any).hash = "77d4d0b1276e4f390a6fb17b31458b78";

export default node;
